<template>
    <section class="gallery-ser-wrapper">
        <span class="gallery-top-span">Galeria realizacji</span>
        <ul>
            <!-- <li>
                <img src="../../../public/img/painting/1.jpg" alt="">
            </li> -->
            <li>
                <img src="../../../public/img/painting/2.jpg" alt="">
            </li>
            <li>
                <img src="../../../public/img/painting/3.jpg" alt="">
            </li>
            <li>
                <img src="../../../public/img/painting/4.jpg" alt="">
            </li>
            <li>
                <img src="../../../public/img/painting/5.jpg" alt="">
            </li>
            <li>
                <img src="../../../public/img/painting/6.jpg" alt="">
            </li>
            <li>
                <img src="../../../public/img/painting/7.jpg" alt="">
            </li>
        </ul>
    </section>
</template>

<script>
export default {
    name: 'paint-gallery',
}
</script>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 700px) {
        @content;
    }
}
.gallery-ser-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
    .gallery-top-span {
        font-size: 40px;
        margin: 50px 0 20px 0;
    }
    ul {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 0;
        padding: 0;
        li {
            width: auto;
            list-style-type: none;
            height: auto;
            img {
                max-height: 400px;
                margin: 20px;
                max-width: 100vw;
                @include mobile {
                    margin: 10px;
                    max-height: 500px;
                    padding: 10px;
                }
            }
        }
    }
}
</style>